// extracted by mini-css-extract-plugin
module.exports = {"JobsListContainer":"JobsList_JobsListContainer__1JCSb","JobsList":"JobsList_JobsList__22O9f","Headers":"JobsList_Headers__3sBEz"};